<template>
  <div>
    <v-container>
      <div class="text-h5 font-weight-bold">
        女性細部家族疾病史（若無法確認確診年齡，請填寫999）
      </div>
      <template v-if="問卷['家族乳癌']">
        <div class="mt-8">
          <div class="font-weight-bold">請問罹患乳癌的家人是</div>
        </div>
        <div class="d-flex flex-wrap">
          <div class="item-width d-flex mr-4" v-for="key of 女性三等親">
            <v-checkbox
              class="mb-1"
              v-model="問卷['家人罹患乳癌-' + key]"
              :label="key"
              hide-details
            ></v-checkbox>
            <v-text-field
              v-if="問卷['家人罹患乳癌-' + key]"
              class="mt-0 inline-block input-width"
              v-model="問卷['家人罹患乳癌年齡-' + key]"
              :rules="[(v) => !!v || '此為必填欄位']"
              label="輸入確診年齡"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>
        </div>
      </template>
      <template v-if="問卷['家族子宮頸癌']">
        <div class="mt-8">
          <div class="font-weight-bold">請問罹患子宮頸癌的家人是</div>
        </div>
        <div class="d-flex flex-wrap">
          <div class="item-width d-flex mr-4" v-for="key of 女性三等親">
            <v-checkbox
              class="mb-1"
              v-model="問卷['家人罹患子宮頸癌-' + key]"
              :label="key"
              hide-details
            ></v-checkbox>
            <v-text-field
              v-if="問卷['家人罹患子宮頸癌-' + key]"
              class="mt-0 inline-block input-width"
              v-model="問卷['家人罹患子宮頸癌年齡-' + key]"
              :rules="[(v) => !!v || '此為必填欄位']"
              label="輸入確診年齡"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import { 女性三等親 } from "@/libs/const.js";
export default {
  name: "QuestionContent",
  props: ["valid", "person", "問卷"],
  data: () => ({ 女性三等親 }),
};
</script>
<style lang="scss" scoped>
.item-width {
  width: 200px;
  display: inline-block;
  ::v-deep .v-label {
    width: 50px;
  }
}
.input-width {
  width: 120px;
  ::v-deep .v-input__slot {
    margin: 0;
    padding: 0;
    margin-top: 14px;
    min-height: 32px !important;
  }
  ::v-deep input {
    margin: 0;
    padding: 0;
  }
  ::v-deep .v-label {
    top: 6px !important;
    font-size: 0.875rem;
    width: 100%;
  }
}
</style>
